<template>
  <component :is="element">{{item}}</component>
</template>

<script>
  export default {
    name: "QuestionItem",
    props:{
      item : {type:String, required:true}
    },
    computed:{
      element(){
        if(this.item.length<=60){
          return 'h1';
        }else if(this.item.length<=100){
          return 'h2';
        }else if(this.item.length<=140){
          return 'h3';
        }else {
          return 'h4';
        }

      }
    }
  }
</script>

<style scoped>

</style>